import clsx from 'clsx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import AvatarPhoto from './AvatarPhoto'

import { TLanguages } from '../../../../../shared/const'

import styles from '../style.module.scss'

/*
 * Beschriftung eines Stammdaten-Werts.
 *
 * Gespeichert ist mal der englische, mal der deutsche Text (siehe
 * shared/optionList) — deshalb wird gegen beide Spalten verglichen. Passt der
 * Wert zu keinem Eintrag, wird er unverändert gezeigt: Ein aus den Stammdaten
 * entfernter Arbeitsbereich soll nicht still verschwinden.
 */
const optionLabel = (values, stored, language) => {
	if (!stored) return ''

	const match = (values || []).find(item => item.value_EN === stored || item.value_DE === stored)
	if (!match) return stored

	return language === TLanguages.EN ? match.value_EN : match.value_DE
}

/**
 * Kopf des Profils: Foto, Name, E-Mail und die Zuordnung im Unternehmen.
 *
 * Was vorher über drei Abschnitte verteilt war (Avatarfoto, Name in der
 * Basisinformation, E-Mail unter „Kontakte"), steht hier auf einen Blick —
 * bearbeitet wird es weiter in den Reitern darunter.
 */
function ProfileHeader(props) {
	const { t, i18n } = useTranslation()

	const name = [props.firstName, props.lastName].filter(Boolean).join(' ')

	/*
	 * Bei der Geschäftsführung gilt `isCEO`, nicht der gespeicherte Text: An
	 * Bestandskonten steht dort teils ein alter Wert („CEO / Managing
	 * Director"), den die Stammdaten nicht mehr kennen — der stünde sonst
	 * englisch im Kopf. Der Arbeitsbereich selbst macht es genauso (siehe
	 * components/WorkArea).
	 */
	const ceo = (props.workAreas || []).find(
		item => /ceo/i.test(item.value_EN || '') || /ceo/i.test(item.value_DE || '')
	)
	const stored = props.isCEO ? ceo?.value_EN : props.primaryWorkArea
	const workArea = optionLabel(props.workAreas, stored, i18n.language)

	return (
		<div className={styles.header}>
			<AvatarPhoto isTeacherStudentView={props.isTeacherStudentView} />

			<div className={styles.headerIdentity}>
				<h2 className={styles.headerName}>{name}</h2>
				{props.email && <span className={styles.headerMail}>{props.email}</span>}

				<div className={styles.headerChips}>
					{(workArea || props.isCEO) && <span className={styles.chip}>{workArea || t('CEO')}</span>}
					{props.companyName && (
						<span className={clsx(styles.chip, styles.chipCompany)}>{props.companyName}</span>
					)}
				</div>
			</div>
		</div>
	)
}

ProfileHeader.propTypes = {
	firstName: PropTypes.string,
	lastName: PropTypes.string,
	email: PropTypes.string,
	primaryWorkArea: PropTypes.string,
	isCEO: PropTypes.bool,
	companyName: PropTypes.string,
	workAreas: PropTypes.array,
	isTeacherStudentView: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
	firstName: state.user.profile.firstName,
	lastName: state.user.profile.lastName,
	email: state.user.profile.email,
	primaryWorkArea: state.user.profile.primaryWorkArea,
	isCEO: state.user.profile.isCEO,
	companyName: state.user.profile.EmploymentCompany?.name,
	workAreas: state.options.workAreas
})

export default connect(mapStateToProps)(ProfileHeader)
